import { useMutation, useQuery } from '@tanstack/react-query';
import { Button, Form, Input, message } from 'antd';
import { AxiosError } from 'axios';
import toast from 'react-hot-toast';
import axios from '../../config/axios';
import { useRuthConnectStore } from '../../store/ruth-connect';
import { Integration } from './ruth-connect-types';

const GoHighLevelConnectUI = () => {
	const { setOpenModalId } = useRuthConnectStore();

	const { refetch } = useQuery<Integration[]>({
		queryKey: ['connected-apps'],
	});

	// connect go high level mutation
	const { mutate, isPending } = useMutation({
		mutationFn: async (payload: unknown) => {
			await axios.post('/ruth-connect/integrations', payload, { withCredentials: true });
		},
		onSuccess: () => {
			message.success('GoHighLevel connected successfully.');
			setOpenModalId(null);
			refetch();
		},
		onError: (error) => {
			if (error instanceof AxiosError && error.response) {
				return toast.error(error.response.data.msg);
			}
			toast.error('An error occurred. Please try again.');
		},
	});

	return (
		<Form
			layout="vertical"
			onFinish={(values) => {
				const payload = {
					app_name: 'go_high_level',
					friendly_app_name: 'GoHighLevel Automation',
					logo: 'https://puretalk-dashboard-rh5d8.ondigitalocean.app/images/go_high_level.png',
					data: {
						api_key: values.api_key,
					},
					tools: ['go_high_level_create_contact', 'go_high_level_create_deal', 'go_high_level_create_task'],
				};

				// mutate integration
				mutate(payload);
			}}
		>
			<Form.Item
				label="GoHighLevel API Key"
				name="api_key"
				className="mb-4"
			>
				<Input.TextArea
					autoSize
					size="large"
					required
				/>
			</Form.Item>

			<Form.Item className="mb-0">
				<Button
					type="primary"
					htmlType="submit"
					block
					loading={isPending}
					disabled={isPending}
					className="font-medium"
					size="large"
				>
					Connect
				</Button>
			</Form.Item>
		</Form>
	);
};

export default GoHighLevelConnectUI;
